/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {USER_INTERRUPT_SUCCESSFUL} from "../utils/constants";
import {
    LOADING_PAUSE_FAILED,
    PAUSE_LOADING,
    PAUSE_SUCCESS,
} from "../actions/types";
import {resetNavigationToOverview} from "../navigation/NavigationActions";

export function loadingPauseFailed(error) {
    return {
        type: LOADING_PAUSE_FAILED,
        error
    };
}

export function pauseLoading(bool) {
    return {
        type: PAUSE_LOADING,
        isLoading: bool
    };
}

export function pauseSuccess(response) {
    return {
        type: PAUSE_SUCCESS,
        response
    };
}

export function fetchPause(countDays) {
    return (dispatch) => {
        dispatch(pauseLoading(true));

        post('pause', {
            countDays: countDays
        })
            .then((response) => {
                if (response.msg === USER_INTERRUPT_SUCCESSFUL) {
                    dispatch(pauseSuccess(response));
                    dispatch(resetNavigationToOverview());
                }else{
                    dispatch(pauseSuccess(response));
                }
                dispatch(pauseLoading(false));
            })
            .catch((error) => {
                dispatch(loadingPauseFailed(error));
                dispatch(pauseLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/pause/PauseAction.js